module.exports = __webpack_public_path__ + "img/iron_dog.36eaa6c2.png";